import PaymentFileFormatOld from './PaymentFileFormatOld';
import PaymentFileFormatNew from './PaymentFileFormatNew';
import CompSerialNumFormatOld from './CompSerialNumFormatOld';
import SerialNumberFormatOld from './SerialNumberFormatOld';
import SerialNumberFormatNew from './SerialNumberFormatNew';
import TaxBalanceFormatOld from './TaxBalanceFormatOld';

let Formats = {};

Formats['Complete Tax Serial Number File old'] = <CompSerialNumFormatOld />;
Formats['Payment File old'] = <PaymentFileFormatOld />;
Formats['Payment File new'] = <PaymentFileFormatNew />;
Formats['Requested Serial Number File old'] = <SerialNumberFormatOld />;
Formats['Requested Serial Number File new'] = <SerialNumberFormatNew />;
Formats['Tax Balance File old'] = <TaxBalanceFormatOld />;

export default Formats;
